import { Campaign } from '../../types';

export const castCampaignSettings = (campaign: Campaign): Campaign => {
  if (campaign.displayRules.renderElementId?.startsWith('#')) {
    campaign.displayRules.renderElementId = campaign.displayRules.renderElementId.slice(1);
  }

  return campaign;
};
